module.exports = __webpack_public_path__ + "static/img/kw.496fa466.svg";